export default {
    leftArrow: require("../assets/imgs/left-arrow.svg"),
    rightArrow: require("../assets/imgs/right-arrow.svg"),
    landing: require("../assets/imgs/landing.svg"),
    takeOff: require("../assets/imgs/take-off.svg"),
    date: require("../assets/imgs/date.svg"),
    adult: require("../assets/imgs/adult.svg"),
    child: require("../assets/imgs/child.svg"),
    nextArrow: require("../assets/imgs/next-arrow.svg"),
    prevArrow: require("../assets/imgs/prev-arrow.svg"),
    oneWayFlight: require("../assets/imgs/one-way-flight.svg"),
    roundTripFlight: require("../assets/imgs/round-trip-flight.png"),
    edit: require("../assets/imgs/edit.png"),
    printer: require("../assets/imgs/printer.png"),
    takeLook: require("../assets/imgs/take-look.png"),
    workingInfo: require("../assets/imgs/working-info.svg"),
    passenger: require("../assets/imgs/passenger.svg"),
    birth: require("../assets/imgs/birth.svg"),
    location: require("../assets/imgs/location.svg"),
    passport: require("../assets/imgs/passport.svg"),
    friend: require("../assets/imgs/friend.svg"),
    spouse: require("../assets/imgs/spouse.svg"),
    parent: require("../assets/imgs/parent.svg"),
    logout: require("../assets/imgs/logout.svg"),
    tigerairTaiwan: require("../assets/imgs/tigerair-taiwan.png"),
    loading: require("../assets/imgs/loading.gif"),
    logo: require("../assets/imgs/logo.jpg"),
    gLogo: require("../assets/imgs/g-logo.svg"),
    loginBg: require("../assets/imgs/login-bg.svg"),
    loginFlight: require("../assets/imgs/login-bg-flight.svg"),
    close: require("../assets/imgs/close.svg"),
    trash: require("../assets/imgs/trash.svg"),
    reminderNotice: require("../assets/imgs/reminder-notice.png"),
    triangle: require("../assets/imgs/triangle.svg"),
    whiteArrow: require("../assets/imgs/white-arrow.svg"),
    plus: require("../assets/imgs/plus.svg"),
    infant: require("../assets/imgs/infant.svg")
};